import type { ProductsTranslations } from '../interfaces/products';

export const productsTranslations: ProductsTranslations = {
  page_title: 'Catálogo',
  page_description:
    'Estes são os produtos que Luna e seus outros agentes podem recomendar e vender.',
  stat_active: 'Produtos ativos',
  stat_draft: 'Rascunhos',
  stat_low_stock: 'Estoque baixo',
  stat_out_of_stock: 'Esgotados',
  filter_all: 'Todos',
  filter_active: 'Ativos',
  filter_draft: 'Rascunhos',
  filter_archived: 'Arquivados',
  filter_category_all: 'Todas as categorias',
  sort_recent: 'Recentes',
  sort_best_sellers: 'Mais vendidos',
  sort_low_stock: 'Estoque baixo',
  sort_price_high: 'Maior preço',
  sort_price_low: 'Menor preço',
  sort_name_az: 'Nome A–Z',
  search_placeholder: 'Buscar por nome, SKU ou tag…',
  view_list: 'Vista de lista',
  view_grid: 'Vista de grade',
  action_new_product: 'Novo produto',
  action_export_csv: 'Exportar CSV',
  action_import: 'Importar',
  action_edit: 'Editar',
  action_duplicate: 'Duplicar',
  action_delete: 'Excluir',
  action_change_status: 'Alterar status',
  action_assign_category: 'Atribuir categoria',
  action_channel_availability: 'Disponibilidade por canal',
  bulk_selected: '{{count}} selecionados',
  bulk_clear: 'Limpar seleção',
  table_product: 'Produto',
  table_category: 'Categoria',
  table_status: 'Status',
  table_price: 'Preço',
  table_stock: 'Estoque',
  table_channels: 'Canais',
  table_actions: 'Ações',
  stock_in_stock: 'Em estoque',
  stock_low: 'Baixo',
  stock_out: 'Esgotado',
  status_active: 'Ativo',
  status_draft: 'Rascunho',
  status_archived: 'Arquivado',
  form_title_new: 'Novo produto',
  form_title_edit: 'Editar produto',
  form_subtitle:
    'O que você carregar aqui vai para o catálogo que Luna e seus outros agentes usam para responder, recomendar e fechar vendas.',
  section_basic_info: 'Informações básicas',
  section_basic_info_subtitle:
    'A primeira coisa que seus agentes e clientes veem.',
  section_images: 'Imagens e mídia',
  section_images_subtitle: 'Envie até 15 imagens. A primeira será a capa.',
  section_pricing: 'Preço',
  section_pricing_subtitle: 'Calculamos a margem automaticamente.',
  section_inventory: 'Inventário e envio',
  section_variants: 'Variantes',
  section_variants_subtitle:
    'Crie opções (tamanho, cor, aroma…) e todas as combinações serão geradas.',
  section_seo: 'SEO e contexto para agentes',
  section_seo_subtitle:
    'O que o Google verá e o que seus agentes saberão que não é mostrado ao cliente.',
  field_name: 'Nome do produto',
  field_name_placeholder: 'Ex. Vela aromática edição outono',
  field_description: 'Descrição',
  field_description_placeholder:
    'O que seu agente lerá para responder perguntas',
  field_category: 'Categoria',
  field_brand: 'Marca',
  field_tags: 'Tags',
  field_tags_placeholder: 'Digite e pressione Enter…',
  field_currency: 'Moeda',
  field_price: 'Preço',
  field_compare_price: 'Preço de comparação',
  field_compare_price_hint: 'Mostrado riscado',
  field_cost_per_unit: 'Custo por unidade',
  field_cost_per_unit_hint: 'Não mostrado ao cliente',
  field_margin: 'Margem',
  field_profit: 'Lucro',
  field_tax_toggle: 'Cobrar impostos sobre este produto',
  field_sku: 'SKU',
  field_sku_hint: 'Único — sincroniza com Shopify',
  field_barcode: 'Código de barras (ISBN/UPC)',
  field_track_inventory: 'Controlar inventário',
  field_track_inventory_hint: '{{brand}} avisará quando o estoque estiver baixo.',
  field_continue_selling: 'Continuar vendendo sem estoque',
  field_continue_selling_hint: 'Útil para pré-vendas ou backorder.',
  field_stock: 'Estoque disponível',
  field_low_stock_threshold: 'Alertar estoque baixo em',
  field_warehouse: 'Armazém',
  field_is_physical: 'Produto físico',
  field_is_physical_hint: 'Ativa peso e dimensões para calcular frete.',
  field_weight: 'Peso',
  field_length: 'Comprimento',
  field_width: 'Largura',
  field_height: 'Altura',
  field_has_variants: 'Este produto tem variantes',
  field_has_variants_hint:
    'Se não, você vende uma única versão e o preço + estoque acima serão suficientes.',
  field_option_name: 'Nome da opção',
  field_add_value: 'Adicionar valor',
  field_add_option: 'Adicionar outra opção',
  field_remove_option: 'Remover opção',
  field_variant_name: 'Variante',
  field_variant_price: 'Preço',
  field_variant_sku: 'SKU',
  field_variant_stock: 'Estoque',
  field_show_more_variants: '+ {{count}} variantes mais · Ver todas',
  field_seo_title: 'Título SEO',
  field_seo_title_hint: '60 caracteres recomendados',
  field_meta_description: 'Meta descrição',
  field_meta_description_hint: '155 caracteres recomendados',
  field_agent_notes: 'Notas internas para o agente',
  field_agent_notes_hint: 'Somente sua equipe e agentes podem ver',
  field_seo_suggest_ai: 'Sugerir com IA',
  sidebar_status: 'Status',
  sidebar_status_active: 'Ativo — visível para agentes',
  sidebar_status_draft: 'Rascunho — somente você',
  sidebar_status_archived: 'Arquivado',
  sidebar_channels: 'Disponível em',
  sidebar_visible_to_agents: 'Agentes com acesso',
  sidebar_visible_to_agents_all_label: 'Todos os agentes',
  sidebar_visible_to_agents_hint:
    'Ative "Todos os agentes" para que qualquer agente recomende este produto. Desative para escolher agentes específicos.',
  sidebar_visible_to_agents_empty:
    'Ainda não há agentes de e-commerce. Crie um para atribuir visibilidade.',
  sidebar_checklist: 'Lista de verificação',
  sidebar_checklist_subtitle: '{{done}} de {{total}} concluídos',
  sidebar_ai_title: '{{brand}} AI pode ajudá-lo',
  sidebar_ai_description:
    'Cole uma URL, uma foto ou descreva o produto e geraremos nome, descrição, tags e SEO em segundos.',
  sidebar_ai_button: 'Gerar com IA',
  channel_whatsapp: 'WhatsApp',
  channel_instagram: 'Instagram DM',
  channel_web: 'Web chat',
  channel_shopify: 'Loja Shopify',
  checklist_name: 'Nome e descrição',
  checklist_image: 'Pelo menos 1 imagem',
  checklist_price: 'Preço definido',
  checklist_sku: 'SKU para inventário',
  checklist_category: 'Categoria atribuída',
  action_discard: 'Descartar',
  action_save_draft: 'Salvar rascunho',
  action_publish: 'Publicar produto',
  action_save: 'Salvar alterações',
  toast_created: 'Produto criado com sucesso',
  toast_updated: 'Produto atualizado com sucesso',
  toast_deleted: 'Produto excluído com sucesso',
  toast_bulk_status: 'Status atualizado com sucesso',
  toast_bulk_category: 'Categoria atribuída com sucesso',
  toast_bulk_channels: 'Canais atualizados com sucesso',
  toast_bulk_deleted: 'Produtos excluídos com sucesso',
  toast_error: 'Ocorreu um erro. Tente novamente.',
  category_create_short: 'Nova',
  category_create_action: 'Criar categoria',
  category_create_dialog_title: 'Nova categoria',
  category_create_name_label: 'Nome',
  category_create_name_placeholder: 'Ex. Velas aromáticas',
  category_create_dialog_confirm: 'Criar',
  category_created: 'Categoria criada',
  import_card_title: 'Importar de uma URL',
  import_card_description:
    'Cole o link de um produto e preenchemos o formulário para você só revisar o essencial. Hoje suportamos Shopify; mais plataformas em breve.',
  import_card_placeholder: 'https://sua-loja.com/products/...',
  import_card_action: 'Importar',
  import_card_footer:
    'Apenas Shopify por enquanto · isso não salva o produto, só preenche o formulário.',
  import_success_title: 'Produto importado',
  import_success_description:
    'Revise os campos antes de publicar. Imagens, variantes e preços vêm do produto original.',
  import_success_toast: 'Importado. Revise antes de salvar.',
  import_undo: 'Desfazer importação',
  import_category_hint:
    'Categoria sugerida da origem: "{{name}}". Escolha acima ou crie uma nova.',
  import_category_hint_dismiss: 'Ok',
  import_error_invalid_url: 'A URL não é válida.',
  import_error_not_supported:
    'Por enquanto só suportamos URLs de produtos do Shopify.',
  import_error_fetch_failed:
    'Não conseguimos acessar a loja. Verifique o link e tente novamente.',
  import_error_invalid_json:
    'Essa URL não retornou um produto Shopify válido. Cole a URL do produto.',
  import_error_unknown: 'Não foi possível importar o produto. Tente novamente.',
  empty_title: 'Sem produtos ainda',
  empty_description:
    'Crie seu primeiro produto para que seus agentes possam recomendá-lo.',
  delete_title: 'Excluir produto',
  delete_description:
    'Tem certeza de que deseja excluir este produto? Esta ação não pode ser desfeita.',
  delete_confirm: 'Excluir',
  delete_cancel: 'Cancelar',
  image_dropzone_text: 'Arraste imagens aqui ou clique para selecionar',
  image_dropzone_specs: 'PNG, JPG, WEBP · máx. 5 MB · 1:1 recomendado',
  image_primary: 'Principal',
  image_set_primary: 'Definir como principal',
  image_delete: 'Excluir',
  pagination_showing: 'Mostrando {{from}}–{{to}} de {{total}}',
  shopify_banner_title: 'Conecte Shopify para sincronizar seu catálogo',
  shopify_banner_description:
    'Quando conectar, os produtos serão vinculados por SKU e o estoque será atualizado em tempo real.',
  shopify_banner_button: 'Conectar Shopify',
  shopify_banner_badge: 'Em breve',
  table_updated: 'Atualizado',
  table_results: '{{count}} produtos',
  pagination_prev: 'Anterior',
  pagination_next: 'Próximo',
  list_select_all: 'Selecionar todos',
  list_deselect_all: 'Desmarcar todos',
  list_filter_label: 'Filtrar por status',
  list_sort_label: 'Ordenar produtos',
  preview_title: 'Pré-visualização',
  preview_subtitle: 'Como aparece quando Luna o recomenda no chat.',
  preview_message: 'Tenho exatamente o que você procura! Olha esta opção:',
  preview_view_detail: 'Ver detalhes',
  preview_default_name: 'Nome do produto',
  preview_variants_available: '{{count}} variantes disponíveis',
  footer_autosave: 'Alterações salvas automaticamente',
  footer_test_sandbox: 'Testar no Sandbox',
  variants_table_count: 'Variante ({{count}})',
  variants_more_count: '+ {{count}} variantes mais',
  image_make_primary: 'Tornar principal',
  image_remove: 'Remover',
  image_count: '{{count}} / 15',
  bulk_change_status_to: 'Alterar para',
  bulk_set_active: 'Ativar',
  bulk_set_draft: 'Marcar como rascunho',
  bulk_set_archived: 'Arquivar',
  no_match_title: 'Não encontramos produtos com esses filtros',
  no_match_description:
    'Tente ajustar a busca, mudar a categoria ou limpar os filtros ativos.',
  no_match_clear: 'Limpar filtros',
  validation_required: 'Este campo é obrigatório',
  validation_min: 'Deve ser maior ou igual a {{min}}',
  validation_max: 'Máximo de {{max}} caracteres',
  validation_must_be_number: 'Deve ser um número válido',
  validation_compare_gt_price:
    'O preço de comparação deve ser maior que o preço',
  sections_title: 'Seções do produto',
  sections_subtitle:
    'Blocos de informação que Luna usa ao recomendar este produto.',
  sections_templates_label: 'Modelos',
  sections_template_benefits: 'Benefícios',
  sections_template_features: 'Características',
  sections_template_usage: 'Modo de uso',
  sections_template_specs: 'Especificações',
  sections_template_whats_included: 'O que inclui',
  sections_template_target_audience: 'Para quem é',
  sections_template_care: 'Cuidados',
  sections_template_warranty: 'Garantia',
  sections_template_faq: 'Perguntas frequentes',
  section_title_placeholder: 'Título da seção',
  section_content_placeholder:
    'Escreva o conteúdo que Luna e seus agentes verão…',
  section_add_custom: 'Adicionar seção personalizada',
  section_remove: 'Remover seção',
  section_reorder: 'Reordenar',
  sections_empty:
    'Sem seções ainda. Comece com um modelo ou crie uma personalizada.',
  sections_cap_reached:
    'Você atingiu o limite de {{max}} seções. Remova alguma para adicionar mais.',
  relations_title: 'Produtos relacionados',
  relations_subtitle:
    'O agente os usa para sugerir complementos, combos e alternativas.',
  relation_type_upsell: 'Upsell',
  relation_type_cross_sell: 'Cross-sell',
  relation_type_bundle: 'Bundle',
  relation_type_accessory: 'Acessório',
  relations_search_placeholder: 'Buscar no catálogo…',
  relations_add_to: 'Adicionar a {{type}}',
  relations_remove: 'Remover da lista',
  relations_empty: 'Sem produtos em {{type}} ainda.',
  relations_bundle_discount: 'Desconto de bundle (%)',
  relations_open_in_new_tab: 'Abrir em nova aba',
};
